import PageBody from "../PageBody";
import NewNotificationType from "../components/pages/notifications/NewNotificationType";

const NewNotificationTypePage = () => {
  return (
    <PageBody>
      <NewNotificationType />
    </PageBody>
  );
};

export default NewNotificationTypePage;
